/**
 * Google Analytics 4 helper.
 *
 * Page views are fired manually on route change (see AnalyticsTracker in App.js).
 * Conversion events are fired from product components.
 */

const GA_ID = 'G-9ZM9FFJ3YY';

function safeGtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

export function trackPageView(path, title) {
  safeGtag('event', 'page_view', {
    page_path: path,
    page_title: title || document.title,
    page_location: window.location.href,
    send_to: GA_ID,
  });
}

export function trackEvent(name, params = {}) {
  safeGtag('event', name, params);
}

/* ---------- Conversion helpers (typed wrappers) ---------- */

export function trackBeginCheckout({ value, quantity, source, paymentMethod, colors }) {
  trackEvent('begin_checkout', {
    currency: 'USD',
    value,
    items: [
      {
        item_id: 'gafas-la-tri',
        item_name: 'Gafas La Tri',
        item_brand: 'Gafas La Tri',
        item_category: 'Sunglasses',
        item_variant: Array.isArray(colors) ? colors.join(', ') : colors,
        quantity,
        price: quantity > 0 ? +(value / quantity).toFixed(2) : value,
      },
    ],
    source: source || 'direct',
    payment_method: paymentMethod || 'unknown',
  });
}

export function trackPurchase({ orderId, value, quantity, source }) {
  trackEvent('purchase', {
    transaction_id: orderId,
    currency: 'USD',
    value,
    items: [
      {
        item_id: 'gafas-la-tri',
        item_name: 'Gafas La Tri',
        item_brand: 'Gafas La Tri',
        item_category: 'Sunglasses',
        quantity,
        price: quantity > 0 ? +(value / quantity).toFixed(2) : value,
      },
    ],
    source: source || 'direct',
  });
}

export function trackWhatsAppClick({ location, source, value, quantity }) {
  trackEvent('whatsapp_click', {
    location,
    source: source || 'direct',
    value,
    quantity,
  });
}

export function trackB2BQuoteRequest({ quantity, totalValue, unitPrice, discountPct }) {
  trackEvent('b2b_quote_request', {
    currency: 'USD',
    quantity,
    value: totalValue,
    unit_price: unitPrice,
    discount_pct: discountPct,
    source: 'empresas',
  });
}
